import { render, staticRenderFns } from "./FavouriteSongs.vue?vue&type=template&id=2284c75e"
import script from "./FavouriteSongs.vue?vue&type=script&lang=js"
export * from "./FavouriteSongs.vue?vue&type=script&lang=js"
import style0 from "./FavouriteSongs.vue?vue&type=style&index=0&id=2284c75e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports